import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'kt-parcel-consideration-modal',
  templateUrl: './parcel-consideration-modal.component.html',
  styleUrls: ['./parcel-consideration-modal.component.scss']
})
export class ParcelConsiderationModalComponent implements OnInit {
  @Input() 
  parcel_tenures: any[];

  constructor(
    private activeModal: NgbActiveModal
  ) { }

  close() {
    this.activeModal.close();
  }

  ngOnInit(): void {
  }

}
